/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_EtbisInputs */

const tr_onbilgi_s1_label_etbis = /** @type {(inputs: Onbilgi_S1_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Kayıt No:`)
};

const en_onbilgi_s1_label_etbis = /** @type {(inputs: Onbilgi_S1_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Registration No:`)
};

const de_onbilgi_s1_label_etbis = /** @type {(inputs: Onbilgi_S1_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS-Registriernummer:`)
};

const ru_onbilgi_s1_label_etbis = /** @type {(inputs: Onbilgi_S1_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрационный номер ETBİS:`)
};

/**
* | output |
* | --- |
* | "ETBİS Registration No:" |
*
* @param {Onbilgi_S1_Label_EtbisInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_etbis = /** @type {((inputs?: Onbilgi_S1_Label_EtbisInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_EtbisInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_etbis(inputs)
	if (locale === "de") return de_onbilgi_s1_label_etbis(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_etbis(inputs)
	return tr_onbilgi_s1_label_etbis(inputs)
});